import { render, staticRenderFns } from "./ModalCreateKpi.vue?vue&type=template&id=30fd040f&"
import script from "./ModalCreateKpi.vue?vue&type=script&lang=js&"
export * from "./ModalCreateKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports